import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { V_URL } from "../../../BaseUrl";
import toast from "react-hot-toast";

export const updateStoreQuotation = createAsyncThunk('/user/update-store-quotation',
    async ({ id, payload }) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/update-store-quotation/${id}`;

            const response = await axios({
                method: 'put',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });
            const data = response.data;
            if (data.success === true) {
                toast.success(response?.data?.message || "Quotation Inquery Submitted Successfully");
                return data;
            } else {
                toast.error(response?.data?.message || "Something went wrong");
                throw new Error(response?.data?.message || "Something went wrong");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return error
        }
    })

const updateStoreQuotationSlice = createSlice({
    name: "updateStoreQuotation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateStoreQuotation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStoreQuotation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(updateStoreQuotation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default updateStoreQuotationSlice.reducer;